<template>
    <div class="sidebar-modal row d-md-none" :class="stickyModallClassMarginBottom">
        <div class="sticky-modal col-12" :class="stickyModalClass">
            <div class="position-relative modal-btn-container" @click="showModal = true">
                <div type="text" class="form-control modal-input">General</div>
                <img src="/img/arrow-down.svg" loading="lazy" alt="arrow-down" class="arrow-down"/>
            </div>
        </div>

        <div v-if="showModal" class="nav-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button @click="showModal = false" type="button" class="btn-close">
                            <img src="/img/close-modal.svg" loading="lazy" alt="close-modal"/>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-for="(category, index) in sideNavData">
                            <h4 class="mt-4">
                                <template v-if="category.url !== null">
                                    <a :href="category.url">
                                        {{ category.title }}
                                    </a>
                                </template>
                                <template v-else>
                                    {{ category.title }}
                                </template>
                            </h4>
                            <template v-if="category.pages.length > 0">
                                <div class="modal-submenu d-flex flex-column">
                                    <a v-for="page in category.pages"
                                       :href="page.url"
                                       @click="showModal = false"
                                       class="modal-link"
                                    >
                                        {{ page.key }}. {{ page.title }}
                                    </a>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NavModal',
        props: {
            sideNavData: {
                type: Array,
                default: null
            }
        },
        data() {
            return {
                showModal: false,
                stickyModalClass: '',
                stickyModallClassMarginBottom: ""
            }
        },
        mounted() {
            window.addEventListener('scroll', this.updateScroll);
        },
        methods: {
            updateScroll() {
                let offsetTop = window.pageYOffset;
                let stickyModalClass = '';
                let stickyModallClassMarginBottom = '';
                if (offsetTop >= 1) {
                    stickyModalClass = 'sticky';
                    stickyModallClassMarginBottom = "active"
                }

                this.stickyModalClass = stickyModalClass;
                this.stickyModallClassMarginBottom = stickyModallClassMarginBottom;
            }
        }
    }
</script>
